const categoryAjaxLoadMore: HTMLButtonElement = document.querySelector(
  '.js-category-ajax-load-more',
) as HTMLButtonElement
const categoryAjaxContainer = document.querySelector(
  '.js-category-ajax-container',
) as HTMLDivElement

const categoryAjaxAdminUrl = ajaxObject.ajaxUrl

let currentPage: number = 2

if (categoryAjaxLoadMore) {
  categoryAjaxLoadMore.addEventListener('click', function () {
    const category = categoryObject.categoryId
    const url = `${categoryAjaxAdminUrl}?action=load_more_posts&page=${currentPage}&category=${category}`

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    })
      .then((response) => response.text())
      .then((data) => {
        if (data.trim() === '') {
          categoryAjaxLoadMore.style.display = 'none'
          return
        }

        categoryAjaxContainer?.insertAdjacentHTML('beforeend', data)

        currentPage++
      })
      .catch((error) => {
        console.error('Erro ao carregar mais posts:', error)
      })
  })
}
